/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Level7_Interactive_PeriodInputs */

const en_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEC 2023 – JAN 2024`)
};

const ar_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ديسمبر 2023 – يناير 2024`)
};

const bn_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিসে ২০২৩ – জানু ২০২৪`)
};

const de_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEZ 2023 – JAN 2024`)
};

const es_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DIC 2023 – ENERO 2024`)
};

const fr_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DÉCEMBRE 2023 – JANVIER 2024`)
};

const pt_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEZEMBRO DE 2023 – JANEIRO DE 2024`)
};

const zh_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2023 年 12 月 – 2024 年 1 月`)
};

const tr_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARALIK 2023 – OCAK 2024`)
};

const ru_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ДЕКАБРЬ 2023 Г. – ЯНВАРЬ 2024 г.`)
};

const pl_experience_level7_interactive_period = /** @type {(inputs: Experience_Level7_Interactive_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRUDZIEŃ 2023 – STYCZEŃ 2024`)
};

/**
* | output |
* | --- |
* | "DEC 2023 – JAN 2024" |
*
* @param {Experience_Level7_Interactive_PeriodInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_level7_interactive_period = /** @type {((inputs?: Experience_Level7_Interactive_PeriodInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Level7_Interactive_PeriodInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_level7_interactive_period(inputs)
	if (locale === "bn") return bn_experience_level7_interactive_period(inputs)
	if (locale === "de") return de_experience_level7_interactive_period(inputs)
	if (locale === "es") return es_experience_level7_interactive_period(inputs)
	if (locale === "fr") return fr_experience_level7_interactive_period(inputs)
	if (locale === "pt") return pt_experience_level7_interactive_period(inputs)
	if (locale === "zh") return zh_experience_level7_interactive_period(inputs)
	if (locale === "tr") return tr_experience_level7_interactive_period(inputs)
	if (locale === "ru") return ru_experience_level7_interactive_period(inputs)
	if (locale === "pl") return pl_experience_level7_interactive_period(inputs)
	return en_experience_level7_interactive_period(inputs)
});